import classes from './ndcHeader.module.scss';

const NDCHeader = ({
  heading,
  isSelected,
  tabIndex: _tabIndex,
}: {
  heading: string;
  isSelected: boolean;
  tabIndex: number;
}) => {
  return (
    <div className={classes.ndcTabContainer}>
      <div className={isSelected ? classes.selectedNDC : classes.unSelectedNDC}>{heading}</div>
    </div>
  );
};

export default NDCHeader;
